export default {"src":"/_next/static/image/src/images/Footer/tiktok.36cebadd7c2dd25fa44e16b89271dde5.svg","height":20,"width":17};